import JsonApi, { JsonApiParams } from "services/JsonApi";
import { Guarantor } from "services/guarantors/types";
import { Reference } from "services/references/types";
import { Resident } from "services/residents/types";
import { Stay } from "services/stays/types";
import { PrePaperworkUserDetails, UserParams } from "services/users/types";

export const initialsFromName = (name?: string) => {
  if (!name) {
    return "";
  }

  const initials = name.replace(/[^A-Z]/g, "");

  if (
    initials.length > 0 &&
    initials.length !== name.replace(/\s/g, "").length
  ) {
    return initials;
  }

  const nameParts = name.split(/[\s-]+/);

  if (nameParts && nameParts.length > 0) {
    return nameParts.map((e) => e.charAt(0).toUpperCase()).join();
  }

  return initials;
};

export const residentsFromOfferDetails = (
  prePaperworkUsers: PrePaperworkUserDetails[] | undefined
) =>
  prePaperworkUsers?.filter(
    (prePaperworkUser) => prePaperworkUser.user_type !== "guarantor"
  );

export const guarantorsFromOfferDetails = (
  prePaperworkUsers: PrePaperworkUserDetails[] | undefined
) =>
  prePaperworkUsers?.filter(
    (prePaperworkUser) => prePaperworkUser.user_type === "guarantor"
  );

export const hasUserWithFinancialIssues = (
  prePaperworkUsers: PrePaperworkUserDetails[] | undefined
) =>
  prePaperworkUsers?.some(
    (prePaperworkUser) => prePaperworkUser.financial_issues
  );

export const availableUserActions = (
  user: Resident | Guarantor | undefined,
  stay: Stay | undefined,
  references: Reference[] | undefined
) => {
  const isStayInProgress =
    user?.joined_midterm || stay?.started_in_situ || stay?.current;

  const referenceRequestIds = references?.map((ref) => ref.id) || [];

  const hasNewPaperwork = user?.applicant_paperworks?.some((paperwork) =>
    referenceRequestIds.includes(String(paperwork.referencing_request_id))
  );
  const showInviteAction =
    !stay?.property?.portfolio?.porch_paperwork_in_join_enabled && // This is so the action doesn't appear in the period between creating the user and the auto issuing of paperwork
    !hasNewPaperwork &&
    (isStayInProgress
      ? Boolean(references?.length)
      : stay?.pre_paperwork_approved_at != null);

  const showReferenceAction = isStayInProgress && !references?.length;

  return {
    isStayInProgress,
    hasNewPaperwork,
    showInviteAction,
    showReferenceAction,
  };
};

export const updateUser = async (
  accessToken: string,
  user: UserParams,
  params: JsonApiParams
) => {
  const api = new JsonApi({ accessToken });

  const { data } = await api.patch("users", user, { params });

  return data;
};
